// eslint-disable-next-line no-restricted-imports
import window from 'window-or-global';

import { CONTEXT_PATH } from '@confluence/named-routes/entry-points/context.ts';

export function redirectToLoginPage(): void {
	window.location = `${CONTEXT_PATH}/login.action?os_destination=${window.location.pathname.replace(
		CONTEXT_PATH,
		'',
	)}` as string & Location;
}
